import { formatEuUsShoeSizeForDisplay } from './shoeSizeDisplay';

/**
 * Stock keys from admin preset stay 5T, 6, 8… — only storefront labels change.
 */
const KIDS_CLOTHING_DISPLAY_BY_KEY = {
  '5T': '5Y',
  '6': '6Y',
  '8': '8Y',
  '10': '10Y',
  '12': '12Y',
};

/** Preset stock keys — if all variants match, treat as kids clothing labels even if category string is off. */
const KIDS_CLOTHING_STOCK_SHAPE = new Set(['2T', '3T', '4T', '5T', '6', '8', '10', '12']);

function normSizeLabel(s) {
  if (typeof s === 'string') return s.trim();
  if (s && typeof s === 'object') {
    return String(s.size || s.name || s.value || '').trim();
  }
  return String(s ?? '').trim();
}

function productSizesLookLikeKidsClothing(product) {
  const sizes = product?.sizes;
  if (!Array.isArray(sizes) || sizes.length < 4) return false;
  const list = sizes.map(normSizeLabel).filter(Boolean);
  if (list.length < 4) return false;
  return list.every((l) => KIDS_CLOTHING_STOCK_SHAPE.has(l));
}

export function isKidsClothingProduct(product) {
  if (!product || typeof product !== 'object') return false;
  const main = String(product.mainCategory ?? '').toLowerCase();
  if (main === 'kids' || main === 'kid') return true;
  const cat = product.category;
  const s = typeof cat === 'string' ? cat : (cat?.name || cat?.slug || cat?.fullPath || '');
  const low = String(s).toLowerCase();
  return (
    low.includes('kid') ||
    low.includes('toddler') ||
    low.includes('children') ||
    low.includes('boys') ||
    low.includes('girls')
  );
}

export function formatKidsClothingSizeForDisplay(sizeKey) {
  const k = String(sizeKey ?? '').trim();
  if (!k) return k;
  return KIDS_CLOTHING_DISPLAY_BY_KEY[k] ?? k;
}

/** PDP size chip / title: kids Y labels, else shoe EU/US short format, else as-is. */
export function getStorefrontSizeDisplay(sizeKey, product) {
  if (isKidsClothingProduct(product) || productSizesLookLikeKidsClothing(product)) {
    return formatKidsClothingSizeForDisplay(sizeKey);
  }
  return formatEuUsShoeSizeForDisplay(sizeKey);
}
